import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { API_BASE_URL, Image_URL } from "../config";

const Customiseorder = () => {
  const [user, setUser] = useState("");
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStage, setSelectedStage] = useState("");

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const parsedUser = JSON.parse(storedUser);
    setUser(parsedUser);
    fetchProducts(parsedUser.companyId);
  }, []);

  const fetchProducts = useCallback(async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/Customised/GetProductCustomizationuser?userid=${id}`);
      if (!response.ok) throw new Error("Failed to fetch products");

      const result = await response.json();
      setProducts(Array.isArray(result.data) ? result.data : []);
    } catch (error) {
      console.error("Error fetching products:", error);
      setProducts([]);
    }
  }, []);

  const filteredProducts = products.filter((product) => {
    // Normalize the product stage to lowercase for comparison
    const normalizedProductStage = product.stage.toLowerCase();

    // Check if selected stage is empty (show all products) or if the product stage matches the selected stage
    return (
      (selectedStage === "" || normalizedProductStage === selectedStage) &&
      // Additional checks for search term matching
      (product.id.toString().includes(searchTerm) ||
        product.stage.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.referenceNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.staffName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.refcustomerName.toLowerCase().includes(searchTerm.toLowerCase()))
    );
  });

  const stageCounts = products.reduce((acc, product) => {
    const normalizedStage = product.stage.toLowerCase(); // Normalize to lowercase
    acc.total += 1;
    acc[normalizedStage] = acc[normalizedStage] ? acc[normalizedStage] + 1 : 1;
    return acc;
  }, { total: 0 });



  // Define the stage order you want to show with human-readable stage names
  const stageOrder = [
    'pending',
    'inquiry accepted',
    'cad design submitted',
    'update delivery date',
    'dispatched',
    'delivered',
    'unable to process',
    'order approved by retailer',
    'order in production'
  ];

  // Function to capitalize each word in the stage name
  const capitalizeStageName = (stage) => {
    return stage
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const handleTotalOrdersClick = () => {
    // Reset search term and selected stage when "Total Orders" is clicked
    setSearchTerm("");
    setSelectedStage(""); // Reset the selected stage to show all orders
  };
  function reconstructFilenames(rawString) {
    const parts = rawString.split(',').map(p => p.trim()).filter(p => p);
    const knownExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'pdf', 'stl', '3dm', 'jcd', 'bmp'];

    const reconstructed = [];
    let currentFile = '';

    for (let i = 0; i < parts.length; i++) {
      if (currentFile) currentFile += ', ' + parts[i]; // add comma and next part
      else currentFile = parts[i];

      const ext = currentFile.split('.').pop().toLowerCase();
      if (knownExtensions.includes(ext)) {
        reconstructed.push(currentFile.trim());
        currentFile = '';
      }
    }

    // Add any leftover part
    if (currentFile) reconstructed.push(currentFile.trim());

    return reconstructed;
  }
  return (
    <>
      <div className="home">
        <div id="page" className="hfeed page-wrapper">
          <Header />
          <div id="site-main" className="site-main">
            <div id="main-content" className="main-content">
              <div id="primary" className="content-area">
                <div id="title" className="page-title" style={{ background: "none", padding: "50px 0" }}>
                  <div className="section-container">
                    <div className="content-title-heading" id="customTabHeader">
                      <h3 className="text-title-heading">
                        <Link to="/partnerdashboard" style={{ color: "black" }} className="btn btn-view">
                          <i className="fa fa-arrow-left" aria-hidden="true"></i>
                        </Link>
                        Existing Custom Orders
                      </h3>
                    </div>

                    <div className="row">
                      <div className="col-md-12 text-right">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search by Order ID, Status, Staff Name, Customer Name, or Reference Code"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          style={{ marginBottom: "20px", maxWidth: "550px" }}
                        />
                      </div>
                    </div>

                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '20px' }}>
                      <button
                        className="btn btn-primary"
                        onClick={handleTotalOrdersClick} // Handle click to show all orders
                      >
                        Total Orders: {products.length}
                      </button>

                      {stageOrder.map((stage) =>
                        stageCounts[stage] ? (
                          <button
                            key={stage}
                            className="btn"
                            onClick={() => {
                              setSelectedStage(stage); // Set selected stage
                              setSearchTerm(""); // Optionally clear search term when a stage is clicked
                            }}
                            style={{
                              backgroundColor:
                                stage === "delivered"
                                  ? "#8cfb8c"
                                  : stage === "dispatched"
                                    ? "#f7ea87"
                                    : ["inquiry accepted", "cad design submitted", "update delivery date", "order approved by retailer", "order in production"].includes(stage)
                                      ? "#96cef6"
                                      : "#8d8989",
                              border: "1px solid #b5b2b2",
                            }}
                          >
                            {capitalizeStageName(stage)}: {stageCounts[stage]}
                          </button>
                        ) : null
                      )}
                    </div>

                  </div>
                </div>

                <div id="content" className="site-content" role="main">
                  <div className="section-padding">
                    <div className="section-container p-l-r">
                      <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                          <div className="tab-content-container">
                            <div className="tab-pane fade show active" id="layout-grid" role="tabpanel">
                              <div className="products-list grid">
                                <div className="row">
                                  {filteredProducts.length > 0 ? (
                                    filteredProducts.map((product) => {
                                      // const images = product.attachment ? product.attachment.split(",") : [];
                                      const images = [
                                        ...reconstructFilenames(product.attachment || ''),
                                        ...reconstructFilenames(product.partnerAttachment || '')
                                      ].filter(img => img && img.trim() !== '');

                                      const firstImage = images.length > 0 ? images[0] : "noimage.jpg";

                                      return (
                                        <div key={product.id} className="col-md-3">
                                          <div
                                            className="customise-product"
                                            style={{
                                              backgroundColor:
                                                product.stage === "Delivered"
                                                  ? "#8cfb8c"
                                                  : "white",
                                            }}
                                          >
                                            <Link to={`/customiseorderlist/${product.userId}/${product.id}`}>
                                              <img
                                                src={`${Image_URL}product/${encodeURIComponent(firstImage)}`}
                                                alt="Product Image"
                                                onError={(e) => {
                                                  e.target.onerror = null; // prevent infinite loop
                                                  e.target.src = `${Image_URL}/product/default.png`; // fallback image
                                                }}
                                              />
                                            </Link>
                                            <div className="details">
                                              <p className="custom-description">
                                                {product.productDescription
                                                  .replace(/&nbsp;/g, " ")
                                                  .replace(/<[^>]*>/g, "")
                                                  .split(" ")
                                                  .filter(word => word.trim() !== "")
                                                  .slice(0, 9)
                                                  .join(" ") + " ..."}
                                              </p>

                                              <div>
                                                <strong>Order ID:</strong> <span>{product.country}-{product.id}</span>
                                              </div>
                                              {/* <div>
                                                <strong>Customer Name:</strong> <span>{product.userName}</span>
                                              </div> */}
                                              <div>
                                                <strong>Customer Name:</strong> <span>{product.refcustomerName}</span>
                                              </div>
                                              <div>
                                                <strong>Staff Name:</strong> <span>{product.staffName}</span>
                                              </div>
                                              <div>
                                                <strong>Order Reference:</strong> <span>{product.referenceNo}</span>
                                              </div>

                                              <div>
                                                <strong>Status:</strong> <span>{product.stage}</span>
                                              </div>
                                              <div>
                                                <strong>Created on:</strong>
                                                <span>
                                                  {product.createdOn
                                                    ? new Date(product.createdOn).getFullYear() === 1900
                                                      ? "-"
                                                      : new Date(product.createdOn).toLocaleDateString("en-GB")
                                                    : "-"}
                                                </span>
                                              </div>
                                              <div>
                                                <strong>Client Delivery Date:</strong>
                                                <span>
                                                  {product.deliveryDate
                                                    ? new Date(product.deliveryDate).getFullYear() === 1900
                                                      ? "-"
                                                      : new Date(product.deliveryDate).toLocaleDateString("en-GB")
                                                    : "-"}
                                                </span>
                                              </div>
                                              <div>
                                                <strong>Admin Delivery Date:</strong>
                                                <span>
                                                  {product.approxDeliveryDays
                                                    ? new Date(product.approxDeliveryDays).getFullYear() === 1900
                                                      ? "-"
                                                      : new Date(product.approxDeliveryDays).toLocaleDateString("en-GB")
                                                    : "-"}
                                                </span>
                                              </div>
                                              <div>
                                                <strong>Last Updated on:</strong>
                                                <span style={{
                                                  backgroundColor:
                                                    product.modifiedBy === "Admin"
                                                      ? "#FF7074"
                                                      : "white",
                                                  color:
                                                    product.modifiedBy === "Admin"
                                                      ? "black"
                                                      : "black",
                                                }}>
                                                  {product.modifiedOn
                                                    ? new Date(product.modifiedOn).getFullYear() === 1900
                                                      ? "-"
                                                      : new Date(product.modifiedOn).toLocaleDateString("en-GB")
                                                    : "-"} ({product.modifiedBy})
                                                </span>

                                              </div>
                                            </div>
                                            <Link to={`/customiseorderlist/${product.userId}/${product.id}`} className="btn btn-view">
                                              View Order
                                            </Link>
                                          </div>
                                        </div>
                                      );
                                    })
                                  ) : (
                                    <p>No matching orders found.</p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Customiseorder;
